import { App } from 'vue';
import { Field, Form } from 'vee-validate';
import BaseButton from '@/components/common/BaseButton.vue';
import BaseCheckbox from '@/components/common/BaseCheckbox.vue';
import BaseImage from '@/components/common/BaseImage.vue';
import BaseInput from '@/components/common/BaseInput.vue';
import BaseModal from '@/components/common/BaseModal.vue';
import BaseRadio from '@/components/common/BaseRadio.vue';
import BaseSelect from '@/components/common/BaseSelect.vue';
import BaseVideo from '@/components/common/BaseVideo.vue';
import Pagination from '@/components/common/Pagination.vue';
import TabSelector from '@/components/common/TabSelector.vue';

const registerGlobalComponents = (app: App<Element>) => {
  app.component('VeeForm', Form);
  app.component('VeeField', Field);
  app.component('BaseInput', BaseInput);
  app.component('BaseButton', BaseButton);
  app.component('BaseModal', BaseModal);
  app.component('BaseCheckbox', BaseCheckbox);
  app.component('BaseSelect', BaseSelect);
  app.component('BaseRadio', BaseRadio);
  app.component('Pagination', Pagination);
  app.component('TabSelector', TabSelector);
  app.component('BaseImage', BaseImage);
  app.component('BaseVideo', BaseVideo);
};

export default registerGlobalComponents;
